import axiosInstance from './axios'

export interface ResolveShortLinkResponse {
  url: string
}

/** Resolves a short link code (from an SMS) to the full destination URL. Anonymous endpoint. */
export const resolveShortLink = async (
  code: string,
): Promise<{ data: ResolveShortLinkResponse }> => {
  return axiosInstance.get(`/short-links/${encodeURIComponent(code)}`)
}
